import { render, staticRenderFns } from "./pro-action-more.vue?vue&type=template&id=e5f8edce";
import script from "./pro-action-more.vue?vue&type=script&lang=js";
export * from "./pro-action-more.vue?vue&type=script&lang=js";
import style0 from "./pro-action-more.vue?vue&type=style&index=0&id=e5f8edce&prod&lang=less";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;